import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Badge,
  Table,
} from "reactstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CustomerSidebar from "../components/CustomerSidebar";
import AddressCard from "../components/AddressCard";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
} from "../global/browserFunctions";

class Address extends Component {
  constructor(props) {
    super(props);
    document.title = "My Addresses";

    if (!getCookie("log")) {
			this.GoToPage("/");
		}
  }

  GoToPage(path) {
		this.props.history.push(path);
	}
  render() {
    return (
      <React.Fragment>
        <Header headermenu={this.headermenu} history={this.props.history} />
        <section className="hero py-6">
                <Container>
                    <Breadcrumb className="pl-0">
                        <BreadcrumbItem><a href="/home">Home</a></BreadcrumbItem>
                        <BreadcrumbItem active>My Address</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="hero-content">
                        <h1 className="hero-heading">My Address</h1>
                    </div>
                </Container>
            </section>
            <section className="pb-6">
                <Container>
                    <Row>
                    <Col xl="3" lg="4" md="4" className="mb-5">
                    <CustomerSidebar  history={this.props.history}/>
                        </Col>
                        <Col lg="8" md="8" xl="9">
                           <AddressCard />
                        </Col>
                       
                    </Row >
                </Container >
            </section >
        <Footer />
      </React.Fragment>
    );
  }
}


export default Address;